export default "__VITE_ASSET__Dgh1kG45__"